import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-RV4R1G258G";

/**
 * Fires a GA4 page_view event on every React-Router route change.
 * The base gtag.js snippet in index.html initialises analytics with
 * `send_page_view: false` so we control when views are counted.
 */
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
}
